import React, { useEffect, useState } from 'react';
import { MTableBody, MTableBodyRow } from 'material-table';
import DialogBox from '../../../../../components/DialogBox';
import { tableIcons } from '../../../../../components/TableIcons';
import DeleteForm from './DeleteForm';
import {
  resetToast,
  FieldDeletionCheck as fieldDeletionCheck,
  resetUdwStatus,
  fetchTypeCodeData,
} from '../../../../../redux/reducers/UserDefinedWindow';
import {
  printDataRepositories,
  resetDockey,
  resetConfigUrl,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../../components/CustomSnackBar';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import { Button, TablePagination } from '@material-ui/core';
import { getUDW } from '../../../../../redux/reducers/UserDefinedWindow';
import { tablePageRows, defaultRows } from '../../../../../constants/ReusableConstants';
import AddIcon from '@material-ui/icons/Add';
import inputStyles from '../../../../../components/InputStyles';
import { resetDbRefData } from '../../../../../redux/reducers/UserDefinedWindow';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/styles';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { postPrintUsage } from '../../../../../redux/reducers/printUsage';
import FormFields from './AddFields';
import moment from 'moment';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import { downloadButton } from '../../../../../util/Content';
import { resetDownloadMsg } from '../../../../../redux/reducers/PreviewFileData';
const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'inherit',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
      textAlign: 'center',
    },
    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
  },
});

// fields table, add field dialog component render (2699250881)

export default function Fields({
  UDWData,
  formData,
  setFormData,
  windowNumber,
  udwView,
  isCopyRowData,
  editable,
  setEditable,
  setDeletedFields,
  deletedFields,
  editExisting,
  reset,
  deleted,
  setDeleted,
  initialValues,
  setEditExisting,
  changedWindowNumber,
  setLookupValuesData,
  dirty,
  dataRepositoryData,
  deletedFieldIds,
  setDeletedFieldIds,
  roleAccess,
  deleteAccess,
  dirtyRef,
  isCriteria,
  isAlreadyExtended,
}) {
  const {
    isLoading,
    errorMsg,
    successMsg,
    udwData,
    fieldDeleteStatus,
    fieldDeleteFromDBStatus,
    fieldDeleteFromDBMessage,
    fieldDeletionLoading,
  } = useSelector(({ userDefinedWindow }) => userDefinedWindow);

  // fetching window details based on window number (2699250881)
  useEffect(() => {
    if (windowNumber) {
      dispatch(getUDW(windowNumber));
    }
  }, [windowNumber, changedWindowNumber]);

  const classes1 = useStyles();
  const classes = inputStyles();
  const dispatch = useDispatch();
  // reset redux state after error or success message (2699250881)
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 4000);
    }
  }, [errorMsg, successMsg, dispatch]);

  // reset redux state after field deletion (2699250881)
  useEffect(() => {
    if (fieldDeleteStatus) {
      setTimeout(() => {
        dispatch(resetToast());
        dispatch(resetUdwStatus());
      }, 3500);
    }
  }, [fieldDeleteStatus]);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [field, setField] = useState('');
  const [dbRef, setDBRef] = useState({});
  const [oldFieldName, setOldFieldName] = useState();
  const [fieldOperation, setFieldOperation] = useState();
  const [maxSequence, setMaxSequence] = useState();
  const [rowData, setRowData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [windowData, setWindowData] = useState([]);
  const [windowId, setWindowId] = useState();
  const [rows, setRows] = useState(defaultRows);
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  const { configurationUrl, dockey } = useSelector(({ dataRepository }) => dataRepository);

  useEffect(() => {
    dispatch(fetchTypeCodeData());
  }, []);
  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  // setting table data after fetching (2699250881)
  useEffect(() => {
    if (udwData && Object.keys(udwData).length > 0 && udwData?.[windowNumber]?.fields) {
      setWindowData(udwData?.[windowNumber]?.fields);
    } else if (udwData && Object.keys(udwData).length > 0 && udwData?.[windowNumber]) {
      setWindowData([]);
    } else {
      setWindowData(formData);
    }
  }, [udwData, windowNumber]);

  // setting table data after fetching for editing window number (2699250881)
  useEffect(() => {
    if (windowData && windowData.length > 0) {
      let editData = [];
      editData = windowData.map((o, i) => ({
        windowFieldId: o?.windowFieldId,
        sequenceNo: o?.sequenceNo ? o?.sequenceNo : '',
        fieldLabel: o?.fieldLabel,
        fieldType: o?.fieldType,
        fieldName: o?.fieldName,
        validationType: o?.validationType ? o?.validationType : null,
        lookupType: o?.lookupType ? o?.lookupType : '',
        isLookUp: o?.isLookUp ? o?.isLookUp : false,
        isActive: o?.isActive ? o?.isActive : 'Y',
        isList: o?.isList,
        fieldOperation: 'N',
        oldFieldName: '',
        listValue: o?.isList?.toLowerCase() === 'dropdown' ? '' : o?.listValue ? o?.listValue : '',
        isMandatory: o?.isMandatory,
        typeCode: o?.isList?.toLowerCase() === 'dropdown' ? o?.listValue?.toString() : '',
        validations: o?.validations,
        globalFieldName: o?.globalFieldName ? o?.globalFieldName : '',
        maximumLength: o?.maximumLength ? o?.maximumLength : '',
        minimumLength: o?.minimumLength ? o?.minimumLength : '',
        displayOptions: {
          isExtended: o?.isExtended,
          isEditable: o?.isEditable,
          isUnique: o?.isUnique,
          isHidden: o?.isHidden,
        },
        additionalOptions: {
          isAuditNote: o?.isAuditNote,
          isAuditTrail: o?.isAuditTrail,
          isTrackChanges: o?.isTrackChanges,
        },
      }));
      if (deleted && deleted?.length > 0) {
        const ids = deleted.map((o) => o.windowFieldId);
        const filtered = editData.filter((item, index) => {
          if (ids.includes(item?.windowFieldId)) {
            return;
          } else {
            return item;
          }
        });
        setEditable(filtered);
      } else {
        setEditable(editData?.length > 0 ? editData : []);
      }
      setWindowId(editData[0].windowId);
    } else {
      setEditable([]);
    }
  }, [windowData, reset]);
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  // handling form data of field for edit (2699256862)
  const handleEdit = (data) => {
    setRowData(data);
    setIsEditMode(true);
    editExisting && data?.windowFieldId && setOldFieldName(data?.fieldName);
    setIsEditOpen(true);
    setEditData(data);
    setField(data?.fieldType);
    setDBRef(data?.globalFieldName);
  };

  // handling data of field for delete (2699256862)
  const handleDelete = (data) => {
    setDeleteData(data);
    data?.fieldId &&
      dispatch(
        fieldDeletionCheck({
          dbTableName: dataRepositoryData?.dbTableName,
          fieldId: data?.fieldId,
          fieldName: data?.fieldName,
          repositoryName: dataRepositoryData?.repositoryName,
          tableColumnName: data?.tableColumnName,
        }),
      );
  };

  // reset delete data after window number change (2699256862)
  useEffect(() => {
    setDeleteData([]);
    setDeletedFields({});
    setDeleted([]);
  }, [windowNumber]);

  // show delete popup if validation status is 200 (2699256862)
  useEffect(() => {
    if (fieldDeleteStatus === 200) {
      setIsDeleteOpen(true);
    }
  }, [fieldDeleteStatus]);

  // reset status after successfully deleting a field (2699256862)
  useEffect(() => {
    if (fieldDeleteFromDBStatus === 200) {
      handleDeleteSubmit();
      setTimeout(() => {
        dispatch(resetToast());
        dispatch(resetUdwStatus());
      }, 2000);
    }
  }, [fieldDeleteFromDBStatus]);

  // showing delete popup without db check for new fields (2699256862)
  useEffect(() => {
    if (!deleteData?.fieldId) {
      Object.keys(deleteData)?.length > 0 && setIsDeleteOpen(true);
    }
  }, [deleteData]);

  // reset if window number is null (2699256862)
  useEffect(() => {
    if (!windowNumber) {
      setEditable([]);
      setFormData([]);
      setWindowId('');
    }
  }, [windowNumber]);

  // used for custom search for table columns (2699250881)
  const getValue = (validations, type) => {
    const item =
      validations && validations.length > 0 && validations.filter((i) => i.type === type);
    if (item && item.length > 0 && item[0].params && item[0].params.length > 0) {
      return item[0].params[0];
    }
  };

  // handling table data for deletion of field (2699256862)
  const handleDeleteSubmit = () => {
    if (windowNumber && editExisting) {
      const filterDelete = editable.filter(
        (item) => item.tableData.id !== deleteData?.tableData?.id,
      );
      if (!deleteData?.windowFieldId) {
        setEditable(filterDelete);
      }
      if (deleteData?.windowFieldId) {
        setEditable(filterDelete);
        const obj = {};
        setDeletedFields(obj);
      }
      dirtyRef.current = true;
    } else {
      dirtyRef.current = true;
      const filteredData = formData.filter((item) => item.sequenceNo !== deleteData.sequenceNo);
      const filter = filteredData.filter((item) => {
        if (deleteData.sequenceNo < item.sequenceNo) {
          return (item.sequenceNo -= 1);
        } else {
          return item.sequenceNo;
        }
      });
      setFormData(filter);
      if (deleteData?.fieldId) {
        const ids = deletedFieldIds?.length > 0 ? [...deletedFieldIds] : [];
        if (ids?.length > 0) {
          setDeletedFieldIds([...ids, deleteData?.fieldId]);
        } else {
          const deleted = [];
          deleted.push(deleteData?.fieldId);
          setDeletedFieldIds(deleted);
        }
      }
    }
  };

  // add field dialog box close (2699256862)
  const handleClose = () => {
    dispatch(resetDbRefData());
    setIsAddOpen(false);
    setIsEditOpen(false);
    setIsDeleteOpen(false);
    setEditData({});
    setIsEditMode(false);
    editData['fieldType'] = field;
    editData['globalFieldName'] = dbRef;
  };

  // delete popup close (2699256862)
  const handleClearDeletion = () => {
    setIsAddOpen(false);
    setIsEditOpen(false);
    setIsDeleteOpen(false);
    setEditData({});
    setIsEditMode(false);
    setDeleteData({});
  };

  // initial columns for fields table (2699250881)
  const coloumns = [
    {
      title: 'S.No',
      render: (rowData) => {
        const rowSeqNo =
          rowData?.tableData?.id === 0
            ? 1
            : rowData?.tableData?.id
              ? rowData?.tableData?.id + 1
              : '';
        if (windowNumber && !isCopyRowData && editable?.length > 0) {
          editable[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        } else if ((isCopyRowData || !windowNumber) && formData?.length > 0) {
          formData[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        }
      },
      customFilterAndSearch: (term, rowData) => {
        return rowData?.sequenceNo?.toString()?.indexOf(term) > -1;
      },
    },
    { title: 'Field Name', field: 'fieldName' },
    { title: 'Field Label', field: 'fieldLabel' },
    {
      title: 'Field Type',
      field: 'fieldType',
      customFilterAndSearch: (term, rowData) => {
        return (
          (rowData?.fieldType === 'string' &&
            rowData?.isList !== 'Y' &&
            'text'?.toString()?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.isList == 'Y' && 'dropdown'?.indexOf(term) > -1) ||
          (rowData?.fieldType !== 'string' &&
            rowData?.fieldType?.toLowerCase()?.indexOf(term.toLowerCase()) > -1)
        );
      },
      render: ({ fieldType, isList }) => (
        <>
          {isList == 'Y' || isList == 'Dropdown'
            ? 'Dropdown'
            : fieldType === 'string'
              ? 'Text'
              : fieldType}
        </>
      ),
    },
    {
      title: 'List Type',
      field: 'listType',
      render: ({ fieldType, isList, listType }) => <>{listType}</>,
    },
    {
      title: 'Min',
      field: 'minimum',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'min')?.toString()?.indexOf(term) > -1;
      },
      render: ({ minLength, minValue, fieldType }) => {
        return minLength
          ? minLength
          : minValue
            ? `${fieldType?.toLowerCase() === 'amount' ? '$' : ''} ${minValue}`
            : '';
      },
    },
    {
      title: 'Max',
      field: 'maximum',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'max')?.toString()?.indexOf(term) > -1;
      },
      render: ({ maxValue, maxLength, fieldType }) => {
        return maxLength
          ? maxLength
          : maxValue
            ? `${fieldType?.toLowerCase() === 'amount' ? '$' : ''} ${maxValue}`
            : '';
      },
    },
    {
      title: 'Mandatory',
      field: 'isMandatory',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.isMandatory === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'View Only',
      field: 'isEditable',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isEditable?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ isEditable, viewOnly }) =>
        viewOnly === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Audit Note',
      field: 'isAuditNote',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isAuditNote?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ isAuditNote }) =>
        isAuditNote === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Unique',
      field: 'isUnique',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isUnique?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ isUnique }) => (isUnique === 'Y' ? <CheckOutlinedIcon color="secondary" /> : ''),
    },
    {
      title: 'Index',
      field: 'isIndexed',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isIndexed?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ isIndexed }) => (isIndexed === 'Y' ? <CheckOutlinedIcon color="secondary" /> : ''),
    },
    {
      title: 'Is Encrypted',
      field: 'isEncripted',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isEncrypted?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ isEncrypted }) =>
        isEncrypted === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Multi Select',
      field: 'multiSelect',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.multiSelect?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({ multiSelect }) =>
        multiSelect === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'IsActive',
      field: 'isActive',
      hidden: true,
    },
  ];

  // on drag end for a field, rearranges rows (2699256862)
  const onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) {
      return;
    }
    if (isCopyRowData || !windowNumber) {
      if (source.index !== destination.index) {
        const copyRows = [...formData];
        const temp = formData[source.index];
        copyRows.splice(source.index, 1);
        copyRows.splice(destination.index, 0, temp);
        setFormData(copyRows);
      }
    } else if (windowNumber) {
      if (source.index !== destination.index) {
        const copyRows = [...editable];
        const temp = editable[source.index];
        copyRows.splice(source.index, 1);
        copyRows.splice(destination.index, 0, temp);
        setEditable(copyRows);
      }
    }
  };
  useEffect(() => {
    setTimeout(() => {
      document && document?.getElementById('table-mat')?.click();
    }, 500);
  }, [editable]);

  return (
    <>
      <DialogBox
        title={isAddOpen ? 'Add Fields' : isEditOpen ? 'Edit Field' : ''}
        open={isAddOpen || isEditOpen}
        dialogClose={handleClose}
        maxWidth="md"
      >
        <FormFields
          handleClose={handleClose}
          setFormData={setFormData}
          formData={formData}
          udwView={udwView}
          dbRef={dbRef}
          data={editData}
          editable={editable}
          setEditable={setEditable}
          windowId={windowId}
          field={field}
          isEditMode={isEditMode}
          rowData={rowData}
          isAddOpen={isAddOpen}
          isEditOpen={isEditOpen}
          oldFieldName={oldFieldName}
          fieldOperation={fieldOperation}
          maxSequence={maxSequence}
          windowNumber={windowNumber}
          isCopyRowData={isCopyRowData}
          editExisting={editExisting}
          setMaxSequence={setMaxSequence}
          setFieldOperation={setFieldOperation}
          setOldFieldName={setOldFieldName}
          setDeletedFieldIds={setDeletedFieldIds}
          dirtyRef={dirtyRef}
          isCriteria={isCriteria}
          isAlreadyExtended={isAlreadyExtended}
        />
      </DialogBox>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Data Repository'}
      />
      <DialogBox title="Delete Field" open={isDeleteOpen} dialogClose={handleClearDeletion}>
        <DeleteForm
          setDeleteData={setDeleteData}
          handleClose={handleClose}
          deleteData={deleteData}
          handleDeleteSubmit={handleDeleteSubmit}
          data={editData}
          setOldFieldName={setOldFieldName}
          initialValues={initialValues}
          setFieldOperation={setFieldOperation}
          deletedFieldIds={deletedFieldIds}
          setDeletedFieldIds={setDeletedFieldIds}
        />
      </DialogBox>
      <div
        id="table-mat"
        className={`${classes1.letterTable} custom-window-table custom-window-table drag-and-drop-table 
        custom-actions-icon custom-toolbar-icons global-field-table new-standard-textfields repository-table  custom-table delete-icon`}
      >
        <GuiTable
          title=""
          icons={tableIcons}
          columns={coloumns}
          data={isCopyRowData ? formData : windowNumber && !isCopyRowData ? editable : formData}
          isLoading={fieldDeletionLoading}
          options={{
            pageSizeOptions: tablePageRows,
            pageSize: rows,
            search: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
            rowStyle: (rowData) => ({
              backgroundColor: rowData.isCriteriaField === 'Y' ? '#f2f8ff' : '#ffff',
            }),
          }}
          components={{
            Pagination: (props) => (
              // Added Rows per screen text in Table pagination (2700780638)
              <div className="global-field-table-footer pagination-block">
                <div className="mt-2">
                  {dataRepositoryData && (
                    <div>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        // disabled={dataRepoUsage.userMetrix === "No"}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              category: dataRepositoryData?.category
                                ? dataRepositoryData?.category
                                : '',
                              fieldListOrderBy: '',
                              fieldListOrderDerection: '',
                              fieldName: dataRepositoryData?.fieldName
                                ? dataRepositoryData.fieldName
                                : '',

                              createdBy: dataRepositoryData?.createdBy?.userName
                                ? dataRepositoryData?.createdBy?.userName
                                : '',
                              createdDate: dataRepositoryData?.createdDate
                                ? moment(dataRepositoryData?.createdDate).format('MM/DD/YYYY')
                                : '',
                              frameworkUsageOrderBy: '',
                              frameworkUsageOrderDerection: '',
                              repositoryName: dataRepositoryData?.repositoryName
                                ? dataRepositoryData.repositoryName
                                : '',
                              repositoryDescription: dataRepositoryData?.repositoryDescription
                                ? dataRepositoryData?.repositoryDescription
                                : '',
                              repositoryType: dataRepositoryData?.repositoryType
                                ? dataRepositoryData?.repositoryType
                                : '',
                              sourceType: 'DATA REPOSITORY',
                              printIndividual: 'Y',
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        // disabled={Boolean(dataCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            printDataRepositories({
                              category: dataRepositoryData?.category
                                ? dataRepositoryData?.category
                                : '',
                              fieldName: dataRepositoryData?.fieldName
                                ? dataRepositoryData.fieldName
                                : '',
                              repositoryName: dataRepositoryData?.repositoryName
                                ? dataRepositoryData.repositoryName
                                : '',
                              repositoryDescription: dataRepositoryData?.repositoryDescription
                                ? dataRepositoryData?.repositoryDescription
                                : '',
                              repositoryType: dataRepositoryData?.repositoryType
                                ? dataRepositoryData?.repositoryType
                                : '',
                              orderBy: '',
                              orderDirection: '',
                              company:
                                dataRepositoryData?.company.length > 0
                                  ? dataRepositoryData?.company.map((i) => i)
                                  : [],
                              printIndividual: 'Y',
                              fieldsSearch: 'N',
                              fieldDescription: '',
                            }),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  )}
                </div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: { 'aria-label': 'Rows per screen' },
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
            Body: (props) => (
              <div>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                    {(provided) => (
                      <div ref={provided.innerRef}>
                        <MTableBody {...props} />
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            ),
            Row: (props) => (
              <Draggable
                draggableId={props.data.tableData.id.toString()}
                index={props.data.tableData.id}
              >
                {(provided) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                  >
                    <MTableBodyRow {...props} />
                  </div>
                )}
              </Draggable>
            ),
          }}
          actions={[
            {
              icon: () => (
                <>
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot}`}
                    // disable based on role access (2699250881)
                    disabled={roleAccess}
                  >
                    <AddIcon />
                    Add Field
                  </Button>
                </>
              ),
              isFreeAction: true,
              disabled: roleAccess,
              onClick: (event) => {
                setIsAddOpen(true);
                setFieldOperation('A');
                setOldFieldName('');
              },
            },
            (rowData) => ({
              icon: () => <EditOutlinedIcon />,
              tooltip: 'Edit',
              disabled: roleAccess,
              onClick: (event, rowData) => handleEdit(rowData),
            }),
            (rowData) => ({
              icon: () => <DeleteOutlineOutlinedIcon />,
              tooltip:
                editExisting && editable?.length === 1
                  ? 'Atleast one field should exist'
                  : 'Delete',
              disabled:
                deleteAccess || (isAlreadyExtended === 'Y' && rowData?.isCriteriaField === 'Y'),
              onClick: (event, rowData) => handleDelete(rowData),
            }),
          ]}
        />
        {(isLoading || isLoadingPrint) && <PageLoader />}
        {fieldDeleteFromDBMessage && <SuccessSnackbar successMsg={fieldDeleteFromDBMessage} />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      </div>
    </>
  );
}
